import config from "@/config";
import http from "@/utils/request";

export default {
	getUserLessonList: {
		url: `${config.API_URL}/admin/user_lesson/getUserLessonList`,
		name: "用户课程列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getUserList: {
		url: `${config.API_URL}/admin/user_lesson/getUserList`,
		name: "用户权限列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getLessonGoodsList: {
		url: `${config.API_URL}/admin/user_lesson/getLessonGoodsList`,
		name: "用户课程权限列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getLessonGoodsListSearch: {
		url: `${config.API_URL}/admin/user_lesson/getLessonGoodsListSearch`,
		name: "用户课程权限商品搜索列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	addUserLesson: {
		url: `${config.API_URL}/admin/user_lesson/addUserLesson`,
		name: "新增用户权限",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	deleteUserLesson: {
		url: `${config.API_URL}/admin/user_lesson/deleteUserLesson`,
		name: "删除用户权限",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	addAllCourseLesson: {
		url: `${config.API_URL}/admin/user_lesson/addAllCourseLesson`,
		name: "批量添加全部课程",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	deleteUserLessonById: {
		url: `${config.API_URL}/admin/user_lesson/deleteUserLessonById`,
		name: "按用户删除课程",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
};
